import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './main/App';
import "normalize.css";
import "typeface-hind";

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js